import { ReportChartGroupItemMeasure } from '@vision/ui/interfaces';

export const ExPieChart1Measures: ReportChartGroupItemMeasure[] = [
  {
    type: 'feedback',
    items: ['feedback-count'],
  },
];
